<avi-confirmation
    class="clr-wrapper"
    (onClose)="handleCancel()"
    [closeOnBackdropClick]="false"
    [closeOnEscapeKeypress]="true"
    [headerText]="l10nKeys.disconnectOnPremLicensingHeader | vtranslate"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div class="disconnect-on-prem-licensing-modal__content">
            <!-- Recommended Section -->
            <div class="disconnect-on-prem-licensing-modal__recommended">
                <div class="disconnect-on-prem-licensing-modal__recommended-header">
                    {{ l10nKeys.recommendedLabel | vtranslate }}
                </div>
                <p class="disconnect-on-prem-licensing-modal__recommended-message">
                    {{ l10nKeys.recommendedMessage | vtranslate }}
                </p>
                <a
                    (click)="handleKbLinkClick($event)"
                    class="disconnect-on-prem-licensing-modal__kb-link"
                >
                    {{ l10nKeys.kbArticleLinkLabel | vtranslate }}
                    <cds-icon
                        shape="pop-out"
                        size="16"
                        class="disconnect-on-prem-licensing-modal__kb-link-button"
                    ></cds-icon>
                </a>
            </div>
            <!-- Force Disconnect Section -->
            <div>
                <p class="disconnect-on-prem-licensing-modal__force-disconnect-message">
                    {{ l10nKeys.forceDisconnectMessage | vtranslate }}
                </p>
                <div class="disconnect-on-prem-licensing-modal__checkbox">
                    <clr-checkbox-wrapper>
                        <input
                            type="checkbox"
                            clrCheckbox
                            [(ngModel)]="forceDisconnectChecked"
                            [disabled]="busy"
                            id="on-Premforce-disconne-checked"
                        />
                        <label for="on-Premforce-disconne-checked">
                            {{ l10nKeys.forceDisconnectCheckboxLabel | vtranslate }}
                        </label>
                    </clr-checkbox-wrapper>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            (click)="handleCancel()"
            (keydown.enter)="handleCancel()"
            [disabled]="busy"
            *ngIf="!forceDisconnectChecked"
        >
            {{ l10nKeys.closeBtnLabel | vtranslate }}
        </cds-button>
        <cds-button
            action="outline"
            (click)="handleCancel()"
            (keydown.enter)="handleCancel()"
            [disabled]="busy"
            *ngIf="forceDisconnectChecked"
        >
            {{ l10nKeys.cancelButtonLabel | vtranslate }}
        </cds-button>
        <cds-button
            (click)="handleForceDisconnect()"
            (keydown.enter)="handleForceDisconnect()"
            status="danger"
            *ngIf="forceDisconnectChecked"
        >
            {{ l10nKeys.forceDisconnectButtonLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
